<template>
  <div class="float-w show" v-if="isShow">
    <div class="float--w">
      <div class="float-tt display-600 not-display-pc">
        <span class="zh">代表作品</span>
        <span class="en"></span>
      </div>
      <div class="btn-close" @click="close()">
        <img src="@/assets/images/icon-close-blk.png" alt="close"/>
      </div>
      <div class="full-bb">
        <div class="bbc-work" v-if="info">
          <div class="bbc-work-w">
            <div class="lp">
              <div class="cover-w">
                <img class="cover" :src="info.cover.b" alt="artist"/>
              </div>
              <p class="hint">{{ info.coverAlt }}</p>
            </div>
            <div class="rp">
              <p class="title">{{ info.name }}</p>
              <div class="row">
                <p class="vv artist">{{ info.artist }}</p>
              </div>
              <div class="row">
                <template v-if="info.exhibitions && info.exhibitions.length">
                  <p class="vv">
                    <a @click="goExhibitionInfo(exhibition)" v-for="(exhibition, index) in info.exhibitions"
                       :key="index">{{ exhibition.title }}</a>
                  </p>
                </template>
              </div>
              <div class="row" v-if="info.year">
                <p class="vv">{{ info.year }}</p>
              </div>
              <div class="row">
                <p class="vv">{{ info.material }}</p>
              </div>
              <div class="row">
                <p class="vv">{{ info.size }}</p>
              </div>
              <div class="row" v-if="info.thanks">
                <p class="vv thanks">{{ info.thanks }}</p>
              </div>
              <p class="intro">
                {{ info.context }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {getArtworkInfo} from "@/api/archives";

export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isShow: true,
      info: null,
    }
  },
  mounted() {
    this.show();
    (new getArtworkInfo).success(res => {
      this.info = res;
    }).run({
      id: this.id
    })
  },
  methods: {
    show() {
      this.isShow = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    },
    goExhibitionInfo(item) {
      item.goDetail();
      this.close();
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/archivesArtwork.vue